import { IconCalendarMonth, IconChartBar, IconCopy, IconDownload, IconHandClick } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import IconButton from '../../../components/Buttons/IconButton';
import TableComponent from '../../../components/DataTable/TableComponent';
import DateRange from '../../../components/DateRange/DateRange';
import { dateIntoYYYY_MM_DD, formatDateToShortMonthDayYear } from '../../../utils/dateTimeConverter';

const TopFiveTable = () => {
    const [selectedTab, setSelectedTab] = useState(1);
    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    });
    const [date, setDate] = useState({ startDate: '', endDate: '' });

    function onDateChange(p) {
        let newDate = { startDate: p.startDate._d, endDate: p.endDate._d }
        setDate(newDate)
    }

    async function getTableData() {
        let postData = {
            startDate: dateIntoYYYY_MM_DD(date.startDate),
            endDate: dateIntoYYYY_MM_DD(date.endDate)
        }
        let resp = await postApi((postData?.startDate ? postData : {}), urlApi.top5Table + selectedTab);
        if (resp.responseCode === 200) {
            setTableData({
                data: resp.data,
                totalCount: resp.data?.length
            });
        } else {
            setTableData({
                data: [],
                totalCount: 0
            });
        }
    }

    function onCopy(copyText) {
        navigator.clipboard
            .writeText(copyText)
            .then(() => {
                toast.success("Link copied");
            })
            .catch(() => {
                toast.error("something went wrong");
            });
    }

    useEffect(() => {
        getTableData();
    }, [selectedTab, date])


    const columns = [
        {
            name: "", selector: (row) => row?.channel_name, grow: 3.2, cell: (row) => (
                <div className='flex items-start py-2 gap-2'>
                    <div className='flex flex-col gap-1 justify-center items-center'>
                        <div className="bg-[var(--primary-30)] p-1.5 aspect-square rounded-full">
                            <img src={selectedTab == 2 ? row?.qrLink : row?.favicon} alt="" className={` ${selectedTab == 2 ? 'h-14' : 'h-6'} aspect-square object-cover`} />
                        </div>
                    </div>
                    <div className="text-left">
                        <p className="mb-0.5 font-semibold text-sm text-[var(--black)]">{row?.linkName}</p>
                        <Link to={row?.shortLink} target='_blank'> <p className="mb-0.5 font-semibold text-primary text-sm">{row?.shortLink}</p></Link>
                        <Link to={row?.mainLink} target='_blank'><p className="mb-0.5 text-xs italic text-[var(--black)]">{row?.mainLink}</p></Link>
                        <div className="flex gap-2">
                            <p className={`font-semibold text-[10px] ${row?.linkClicks > 0 ? 'text-green-500' : 'text-[#BDBDBD]'} inline-flex items-center gap-1 mb-0`}> <span> <IconChartBar size={16} /> </span> {row?.linkClicks ?? "0"} engagements</p>
                            <p className={`font-semibold text-[10px] ${row?.uniqueLinkClicks > 0 ? 'text-green-500' : 'text-[#BDBDBD]'} inline-flex items-center gap-1 mb-0`}> <span> <IconHandClick size={16} /> </span> {row?.uniqueLinkClicks ?? "0"} unique clicks</p>
                            <p className="font-semibold text-[10px] text-[#BDBDBD] inline-flex items-center gap-1 mb-0"> <span> <IconCalendarMonth size={16} /> </span> {formatDateToShortMonthDayYear(row?.createdAt)}</p>
                        </div>
                    </div>
                </div>
            )
        }, {
            name: "", center: "true", grow: 1, selector: (row) => row?.userName, cell: (row) => (
                <Link to={'/user/' + row?.userId} className="text-center">
                    <img src={row?.userProfilePic} alt="" className='h-8 rounded-full aspect-square object-cover bg-slate-500 mx-auto' />
                    <p className="mb-0.5 font-semibold text-sm text-[var(--black)]">{row?.userName}</p>
                </Link>
            )
        }, {
            name: "", center: "true", grow: 1, selector: (row) => row?.category, cell: (row) => (
                <div className="flex gap-2 items-center flex-wrap justify-center">
                    <IconButton icon={< IconCopy size={16} />} text={"Copy"} onClickFunction={() => onCopy(row?.shortLink)} />
                    {selectedTab == 2 && <a href={row?.qrLink} className='no-underline'> <IconButton icon={< IconDownload size={16} />} /></a>}
                    <Link to={row?.linkType == 1 ? "/link-details" : row?.linkType == 2 ? "/qr-details" : row?.linkType == 3 ? "/page-details" : row?.linkType == 5 ? "/business-card-details" : ''} state={row} className='no-underline'>  <IconButton icon={< IconChartBar size={16} />} text={"Details"} /></Link>
                </div>
            )
        }
    ];

    return (
        <div className='bg-white p-3 rounded-lg'>
            <div className='flex justify-between flex-wrap items-center mb-3'>
                <p className="mb-0 text-[17px] text-[var(--grey)] font-bold">Top Performing</p>
                <div className="flex outline outline-[#383c5120] outline-[1px] p-1 rounded-lg gap-2">
                    <button className={`!px-5 py-1 rounded-lg font-bold text-sm ${selectedTab == 1 ? 'bg-primary text-white' : 'bg-transparent text-black'}`} onClick={() => setSelectedTab(1)}>Links</button>
                    <button className={`!px-5 py-1 rounded-lg font-bold text-sm ${selectedTab == 2 ? 'bg-primary text-white' : 'bg-transparent text-black'}`} onClick={() => setSelectedTab(2)}>QR Codes</button>
                    <button className={`!px-5 py-1 rounded-lg font-bold text-sm ${selectedTab == 3 ? 'bg-primary text-white' : 'bg-transparent text-black'}`} onClick={() => setSelectedTab(3)}>Pages</button>
                    <button className={`!px-5 py-1 rounded-lg font-bold text-sm ${selectedTab == 5 ? 'bg-primary text-white' : 'bg-transparent text-black'}`} onClick={() => setSelectedTab(5)}>Cards</button>
                </div>
                {/* <button className='outline outline-[#383c5120] outline-[1px] p-1 rounded-md'><IconDotsVertical size={20} /></button> */}
                <DateRange onApplyClick={(date) => onDateChange(date)} date={date} />
            </div>
            <TableComponent
                columns={columns}
                data={tableData?.data}
                totalRows={tableData?.totalCount}
                isPagination={false}
                noHeader={true}
                paginationPerPage={5}
                handlePageChange={(e) => { }}
                handlePerRowsChange={(newPerPage, page) => { }} />
        </div>
    )
}

export default TopFiveTable